import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SectorsGrid from "../../components/sectors-grid/SectorsGrid.tsx";
import WhiteBlocksList, {
  ITrustedPartnerBlock,
} from "../../ui/components/white-blocks-list/WhiteBlocksList.tsx";
import { ISectorCard } from "../../components/sectors/Sectors.tsx";
import businessAnalysisImage from "../../media/software-implementation/what-we-offer/support.webp";
import softwareDevelopmentImage from "../../media/IT-consulting/code.webp";
import implementationAndSupportImage from "../../media/software-development/development.jpeg";
import bpmPlanningImage from "../../media/partnership/bpm-planning.jpeg";
import bpmIntegrationImage from "../../media/partnership/bpm-integration.jpeg";
import bpmCustomizationImage from "../../media/partnership/bmp-customization.jpeg";
import crownIcon from "../../media/icons/crown.svg";
import wrenchIcon from "../../media/icons/wrench.svg";
import diamondIcon from "../../media/icons/diamond.svg";
import FormCard from "../../components/formCard/FormCard.tsx";
import classes from "./Partnership.module.scss";
import bg from "../../media/background.svg";
import bg768 from "../../media/background-768.svg";
import bg1100 from "../../media/background-1100.svg";
import noise from "../../media/noise.png";
import blueBackground from "../../media/about-us/blue-background.svg";
import {Link} from "react-scroll";


const Partnership = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();

  const aboutUsBlocks = [
    {
      header: [t("partnership.aboutUs.information.0.header")],
      body: t("partnership.aboutUs.information.0.body")
    },
    {
      header: [t("partnership.aboutUs.information.1.header")],
      body: t("partnership.aboutUs.information.1.body")
    },
    {
      header: [t("partnership.aboutUs.information.2.header")],
      body: t("partnership.aboutUs.information.2.body")
    },
  ]

  const sectorCards: ISectorCard[] = [
    {
      image: businessAnalysisImage,
      title: t("partnership.collaborationOpportunities.blocks.0.title"),
      text: t("partnership.collaborationOpportunities.blocks.0.text"),
      id: 1,
    },
    {
      image: bpmPlanningImage,
      title: t("partnership.collaborationOpportunities.blocks.1.title"),
      text: t("partnership.collaborationOpportunities.blocks.1.text"),
      id: 2,
    },
    {
      image: bpmIntegrationImage,
      title: t("partnership.collaborationOpportunities.blocks.2.title"),
      text: t("partnership.collaborationOpportunities.blocks.2.text"),
      id: 3,
    },
    {
      image: bpmCustomizationImage,
      title: t("partnership.collaborationOpportunities.blocks.3.title"),
      text: t("partnership.collaborationOpportunities.blocks.3.text"),
      id: 4,
    },
    {
      image: softwareDevelopmentImage,
      title: t("partnership.collaborationOpportunities.blocks.4.title"),
      text: t("partnership.collaborationOpportunities.blocks.4.text"),
      id: 5,
    },
    {
      image: implementationAndSupportImage,
      title: t("partnership.collaborationOpportunities.blocks.5.title"),
      text: t("partnership.collaborationOpportunities.blocks.5.text"),
      id: 6,
    },
  ];

  const howWeCollaborateList = [
    {
      emoji: "🤝",
      title: t("partnership.howWeCollaborate.lists.0.title"),
      items: t("partnership.howWeCollaborate.lists.0.items", {
        returnObjects: true,
      }),
    },
    {
      emoji: "🛠️",
      title: t("partnership.howWeCollaborate.lists.1.title"),
      items: t("partnership.howWeCollaborate.lists.1.items", {
        returnObjects: true,
      }),
    },
    {
      emoji: "✅",
      title: t("partnership.howWeCollaborate.lists.2.title"),
      items: t("partnership.howWeCollaborate.lists.2.items", {
        returnObjects: true,
      }),
    },
    {
      emoji: "💸",
      title: t("partnership.howWeCollaborate.lists.3.title"),
      items: t("partnership.howWeCollaborate.lists.3.items", {
        returnObjects: true,
      }),
    },
  ];

  const whyChooseUsBlocks: ITrustedPartnerBlock[] = [
    { title: t("partnership.whyChooseUs.blocks.0"), icon: crownIcon },
    { title: t("partnership.whyChooseUs.blocks.1"), icon: wrenchIcon },
    { title: t("partnership.whyChooseUs.blocks.2"), icon: diamondIcon },
  ];

  return (
    <main>
      <section className={classes.container} id="nav-dark">
        <img alt="" className={classes.background} src={bg}/>
        <img alt="" className={classes['background-768']} src={bg768}/>
        <img alt="" className={classes['background-1100']} src={bg1100}/>
        <img alt="" className={classes.noise} src={noise}/>

        <div className={classes.content}
        >
          <div className={classes.text}>
            <h1>{t("partnership.heading.textWhite")}<span className={classes.gradient}>{t("partnership.heading.textBlue")}</span></h1>
            <p>{t("partnership.heading.message")}</p>
           <Link to={'contact'} smooth={true}><span>{t("partnership.heading.buttonText")}</span></Link>
          </div>
        </div>
      </section>

      <section className="section--white" id="nav-dark">
        <div className={classes['about-us']}>
          <div className={classes["blocks-container"]}>
            {aboutUsBlocks.map((item, index) => {
                  return (
                      <div
                          className={`${classes.block} ${classes[`block--${index + 1}`]}`}
                          key={item.body}
                      >
                        <img
                            className={`${classes["block-background"]} ${classes[`block-background--${index + 1}`]}`}
                            src={require(
                                `../../media/about-us/block-background-${index + 1}.svg`,
                            )}
                            alt="block background"
                        />
                        <div className={classes["block-background--blue-container"]}>
                          <img
                              className={`${classes["block-background--blue"]}  ${classes[`block-background--blue--${index + 1}`]}`}
                              src={blueBackground}
                              alt="block background"
                          />
                        </div>
                        <div className={classes["header-container"]}>
                          {typeof item.header === "object" &&
                              item.header.map((header) => (
                                  <h2 className={classes["block-header"]} key={header}>
                                    {header}
                                  </h2>
                              ))}
                        </div>
                        <div className={classes["block-body"]}>{item.body}</div>
                      </div>
                  );
                })}
          </div>
        </div>
      </section>

      <section className={'section--light-gray'}>
        <SectorsGrid
            cards={sectorCards}
            title={t("partnership.collaborationOpportunities.title")}
            subtitle={null}
        />
      </section>

      <section className={'section--white'}>
          <div className={classes.lifecycle}>
            <div className={classes.header}>
              <h2>{t("partnership.howWeCollaborate.title")}</h2>
            </div>

            <div className={classes.cards}>
              {howWeCollaborateList.map((list, i) => (
                  <div key={i}>
                    <span>{list.emoji}</span>
                    <div className={classes.text}>
                      <h5>{list.title}</h5>
                      <ul>
                        {list.items.map(item => (<li key={item}>{item}</li>))}
                      </ul>
                    </div>
                  </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section--dark-gray" id="nav-light">
          <WhiteBlocksList
              title={t("partnership.whyChooseUs.title")}
              blocks={whyChooseUsBlocks}
          />
        </section>

        <section className="section--white" id="nav-dark">
          <FormCard/>
        </section>
    </main>
);
};

export default Partnership;
